import { apiClient } from './httpClient';
// 文字转语音
export async function synthesizeSpeech(data) {
    const response = await apiClient.post('/tts/synthesize', data);
    return response.data;
}
// 获取可用音色列表
export async function getVoices() {
    const response = await apiClient.get('/tts/voices');
    return response.data;
}
// 按条件筛选音色
export async function filterVoices(filters) {
    const params = new URLSearchParams();
    if (filters.gender)
        params.append('gender', filters.gender);
    if (filters.language)
        params.append('language', filters.language);
    if (filters.emotion)
        params.append('emotion', filters.emotion);
    if (filters.dialect)
        params.append('dialect', filters.dialect);
    const response = await apiClient.get(`/tts/voices/filter?${params.toString()}`);
    return response.data;
}
// 为场景生成配音
export async function generateSceneVoiceover(data) {
    const response = await apiClient.post('/tts/scene-voiceover', data);
    return response.data;
}
